import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./breadcrumbs.css?inline";

@customElement("eko-breadcrumbs")
export class Breadcrumbs extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<ol class="eko-breadcrumbs" aria-label="Breadcrumbs" role="navigation">
      <slot name="breadcrumb"></slot>
    </ol>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-breadcrumbs": Breadcrumbs;
  }
}

export default Breadcrumbs;
